import { useState } from "react";
import { ChevronDown, ChevronUp, Plus } from "lucide-react";
import { getStatusColor } from "../../utils/helper";

const Accordion = ({
  title,
  count,
  children,
  onAdd,
  defaultOpen = false,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="bg-gray-50 rounded-xl mb-4">
      {/* Header */}
      <div
        className={`flex justify-between items-center p-2 cursor-pointer font-semibold text-black rounded-xl shadow-sm hover:shadow-md transition`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className={`flex items-center gap-x-2 `}>
          {isOpen ? <ChevronDown size={18} /> : <ChevronUp size={18} />}
          <div className={`size-2.5 rounded-full ${getStatusColor(title)}`}></div>
          <p>{title}</p>
        </div>

        <div className="flex items-center gap-2">
          <span className="text-xs bg-gray-100 text-gray-700 size-4 flex justify-center items-center rounded-full">
            {count}
          </span>

          {onAdd && (
            <Plus
              size={18}
              className="cursor-pointer text-white bg-[#1E293B] p-1 rounded-full hover:bg-green-600 transition"
              onClick={(e) => {
                e.stopPropagation();
                onAdd();
              }}
            />
          )}
        </div>
      </div>

      {/* Body */}
      {isOpen && (
        <div className="flex flex-col gap-3 py-3 lg:px-2">
          {children}
        </div>
      )}
    </div>
  );
};

export default Accordion;